export function getHcpTypesDisplayLabel(hcpTypes: string[] | undefined): string {
    if (hcpTypes && hcpTypes.length > 0) {
        return hcpTypes.sort((a, b) => a.localeCompare(b)).join(', ');
    }

    return '-';
}
